import {StatusGroupGranularityType} from '@toolify/server/src/services/DatabasePropertyService/strategies/ColumnTypeStrategies/StatusPropertyTypeStrategy/enum/StatusGroupGranularityType'
import {
  IStatusResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IStatusResponseInstance'
import {IconNameType} from '@toolify/server/src/enum/IconNameType'
import {IGroupGranularityDescriptor} from '@toolify/client/src/modules/databases/utils/groupSortModes'
import {i18n} from '@toolify/client/src/setup/i18n'

export const STATUS_GRANULARITY_FULL_LABEL_KEYS: Record<StatusGroupGranularityType, string> = {
  [StatusGroupGranularityType.Status]: 'database.header.granularityStatus',
  [StatusGroupGranularityType.StatusGroup]: 'database.header.granularityStatusGroup',
}

export const STATUS_GRANULARITY_SHORT_LABEL_KEYS: Record<StatusGroupGranularityType, string> = {
  [StatusGroupGranularityType.Status]: '',
  [StatusGroupGranularityType.StatusGroup]: 'database.header.granularityStatusGroupShort',
}

export const statusGroupGranularityDescriptor: IGroupGranularityDescriptor = {
  getDefault: () => StatusGroupGranularityType.Status,
  getValues: () => Object.values(StatusGroupGranularityType),
  getFullLabelKey: (value: string): string =>
    STATUS_GRANULARITY_FULL_LABEL_KEYS[value as StatusGroupGranularityType] ?? '',
  getShortLabelKey: (value: string): string =>
    STATUS_GRANULARITY_SHORT_LABEL_KEYS[value as StatusGroupGranularityType] ?? '',
  icon: IconNameType.LayerGroup,
  mapBucketFullValue: (fullValue, granularity) => {
    const status = fullValue as IStatusResponseInstance | null
    if(granularity !== StatusGroupGranularityType.StatusGroup || !status?.groupType) {
      return fullValue
    }
    return {
      ...status,
      title: i18n.global.t(`database.properties.statusGroup.${status.groupType}`),
    }
  },
  bucketValue: (value, fullValue, granularity) => {
    if(granularity === StatusGroupGranularityType.StatusGroup) {
      return null
    }
    return {
      value,
      fullValue,
    }
  },
}
